import { Button, CircularProgress, Stack, Typography } from "@mui/material";
import { FC, useState } from "react";
import { useBillingInfo } from "../../../hooks";
import { useAppDispatch, useAppSelector } from "../../../redux-store/hooks";
import { createNewBill, updateCartItemOfTheTable } from "../../../services";
import { BillConfimPopup } from "../components";
import { BillProcessDrawer } from "./billing-process-drawer";
import { BillType, TABLE_STATUS } from "../../../all-types";


interface CartPanelItemDetailsProps {
    currentTab: string;
    showBillingScreen: () => void;
    goBack?: () => void;
    isSummary: boolean;
    isCartEmpty: boolean;
    freeTheTable: () => void;
}

const CartPanelItemDetails: FC<CartPanelItemDetailsProps> = ({ currentTab, showBillingScreen, goBack, isSummary, isCartEmpty, freeTheTable }) => {
    const { fullBill } = useBillingInfo(currentTab);
    const dispatcher = useAppDispatch();
    const preloadTables = useAppSelector(state => state.preloadData.tables);
    const [openConfimPopup, setConfimPopup] = useState(false);
    const handleOpenConfimPopup = () => setConfimPopup(true);
    const handleCloseConfimPopup = () => setConfimPopup(false);
    const [loadBilling, setLoadBilling] = useState(true);
    const [createdBill, setCreatedBill] = useState<BillType | null>(null);
    const [syncingKitchen, setSyncingKitchen] = useState(false);

    const [openShareBillDrawer, setOpenShareBillDrawer] = useState(false);

    const toggleShareBillDrawer = (newOpen: boolean) => {
        setOpenShareBillDrawer(newOpen);
    };

    const sendToKitchen = async () => {
        const liveTable = preloadTables.find(t =>
            currentTab === t.tableName.concat(String(t.tableNo)).concat(String(t.floorNo))
        );
        if (!liveTable?._id) return;
        setSyncingKitchen(true);
        try {
            await dispatcher(updateCartItemOfTheTable({
                table: { ...liveTable, status: TABLE_STATUS.OCCUPIED, billSession: fullBill }
            }));
        } catch (e) {
            console.error(e);
        } finally {
            setSyncingKitchen(false);
        }
    };

    const proceedForBilling = () => {
        try {

        } catch (e) {
            console.error(e);
        } finally {
            showBillingScreen();
        }
    }


    const startCreatingBillProcess = async () => {
        try {
            setLoadBilling(true);
            handleCloseConfimPopup();
            toggleShareBillDrawer(true);
            const resp = await dispatcher(createNewBill({ bill: fullBill }));
            setCreatedBill(resp.payload);
        } catch (e) {
            console.error(e);
        } finally {
            setLoadBilling(false);
        }
    }

    return (
        <Stack flex={1} width={"100%"} justifyContent={"flex-end"} p={2}>
            <Stack flexDirection={"row"} justifyContent={"space-between"}>
                <Typography variant="body1"  >
                    Total Items
                </Typography>
                <Typography variant="body1"  >
                    {fullBill.items?.length}
                </Typography>
            </Stack>
            <Stack flexDirection={"row"} justifyContent={"space-between"}>
                <Typography variant="body1"  >
                    Subtotal
                </Typography>
                <Typography variant="body1"  >
                    {fullBill.billingInfo.totalItemsCostRaw}
                </Typography>
            </Stack>

            <Stack flexDirection={"row"} justifyContent={"space-between"}>
                <Typography variant="body1"  >
                    Discount
                </Typography>
                <Typography variant="body1"  >
                    {fullBill.billingInfo.totalDiscountIssued}
                </Typography>
            </Stack>

            <Stack flexDirection={"row"} justifyContent={"space-between"}>
                <Typography variant="body1"  >
                    Tax
                </Typography>
                <Typography variant="body1"  >
                    {fullBill.billingInfo.totalTaxCharged.toFixed(2)}
                </Typography>
            </Stack>

            <Stack flexDirection={"row"} justifyContent={"space-between"}>
                <Typography variant="h6"  >
                    Final Amount
                </Typography>
                <Typography variant="h6"  >
                    {fullBill.billingInfo.finalBillAmount}
                </Typography>
            </Stack>
            {isSummary ? (
                <Stack flexDirection={"row"} justifyContent={"space-between"} gap={1}>
                    <Button variant="contained" color="error" onClick={goBack} fullWidth sx={{ height: 50 }}>Back</Button>
                    <Button variant="contained" color="success"
                        disabled={fullBill.modeOfPayment === ""}
                        fullWidth sx={{ height: 50 }} onClick={handleOpenConfimPopup}>Place Order</Button>
                </Stack>
            ) : (
                <Stack gap={1}>
                    {!isCartEmpty && (
                        <Button
                            variant="outlined"
                            color="warning"
                            fullWidth
                            sx={{ height: 46 }}
                            onClick={sendToKitchen}
                            disabled={syncingKitchen}
                            startIcon={syncingKitchen ? <CircularProgress size={16} color="inherit" /> : null}
                        >
                            {syncingKitchen ? "Syncing..." : "Send to Kitchen"}
                        </Button>
                    )}
                    <Stack flexDirection={"row"} justifyContent={"space-between"} gap={1}>
                        {isCartEmpty && (
                            <Button variant="contained" color="error" fullWidth sx={{ height: 50 }} onClick={freeTheTable}>Hold/Close</Button>
                        )}
                        {!isCartEmpty && (
                            <Button variant="contained" color="success" fullWidth sx={{ height: 50 }} onClick={proceedForBilling}>Proceed</Button>
                        )}
                    </Stack>
                </Stack>
            )}

            <BillConfimPopup handleClose={handleCloseConfimPopup} onConfirm={startCreatingBillProcess} open={openConfimPopup} />
            {/* <BillProcessDrawer isLoading={loadBilling} open={openShareBillDrawer} toggleDrawer={toggleShareBillDrawer} /> */}
        </Stack>
    )
}

export { CartPanelItemDetails };

